<template>
    <b-dropdown :variant="variant">
        <template v-slot:button-content>
            {{ title }}
            <i class="mdi mdi-chevron-down"></i>
        </template>
        <template v-for="(item, index) in datas">
            <b-dropdown-item :key="index" v-if="selectedId != item.id" href="javascript: void(0);" @click="handleSelect(item.id)">{{ item.value }}</b-dropdown-item>
        </template>
    </b-dropdown>  
</template>


<script>
    export default {
        props: {
            variant: String,
            title: String,
            datas: Array,
            handleSelect: Function,
            selectedId: Number
        },
    }
</script>

